import React, { useEffect, useState } from 'react';
import { LAUNCH_DEADLINE } from '../data/resinContent';
type CountdownTimerProps = {
  label: string;
  className?: string;
  size?: 'md' | 'lg';
};
const pad = (n: number) => String(n).padStart(2, '0');
function secondsLeft(): number {
  if (!LAUNCH_DEADLINE) return 0;
  const diff = Math.floor((new Date(LAUNCH_DEADLINE).getTime() - Date.now()) / 1000);
  return Number.isFinite(diff) && diff > 0 ? diff : 0;
}

/** Renders only when a real LAUNCH_DEADLINE is configured and still in the future. */
export function CountdownTimer({
  label,
  className = '',
  size = 'md'
}: CountdownTimerProps) {
  const [remaining, setRemaining] = useState(secondsLeft);
  useEffect(() => {
    if (!LAUNCH_DEADLINE) return;
    const id = window.setInterval(() => setRemaining(secondsLeft()), 1000);
    return () => window.clearInterval(id);
  }, []);
  if (!LAUNCH_DEADLINE || remaining <= 0) return null;
  const days = Math.floor(remaining / 86400);
  const units = [...(days > 0 ? [{
    value: pad(days),
    unit: 'days'
  }] : []), {
    value: pad(Math.floor(remaining % 86400 / 3600)),
    unit: 'hrs'
  }, {
    value: pad(Math.floor(remaining % 3600 / 60)),
    unit: 'min'
  }, {
    value: pad(remaining % 60),
    unit: 'sec'
  }];
  const digit = size === 'lg' ? 'text-4xl sm:text-5xl' : 'text-3xl sm:text-4xl';
  return <div className={className} data-id="element-66" data-mp="172dfk6bmvb8i">
      <p className="text-[10px] font-semibold uppercase tracking-[0.24em] text-champagne" data-id="element-67" data-mp="173oki9gtep17">
        {label}
      </p>
      <div className="mt-2 flex items-start justify-center gap-3 sm:gap-4" role="timer" aria-live="off" data-id="element-68" data-mp="1zq9i3rnvvxd7">
        {units.map(({
        value,
        unit
      }, i) => <React.Fragment key={unit} data-id="element-69" data-mp="1l0tw0ozasg3u" data-mpi={i}>
            {i > 0 && <span className={`font-display font-semibold leading-none text-charcoal-500 ${digit}`} aria-hidden="true" data-id="element-70" data-mp="1pzy1p5n0jvpf">
                :
              </span>}
            <span className="text-center" data-id="element-71" data-mp="2ihsjju29f3d4">
              <span className={`block font-display font-semibold leading-none text-ivory-50 ${digit}`} data-id="element-72" data-mp="2iill8gmd32oe">
                {value}
              </span>
              <span className="mt-1 block text-[9px] font-medium uppercase tracking-[0.2em] text-muted" data-id="element-73" data-mp="2neplqtx129bc">
                {unit}
              </span>
            </span>
          </React.Fragment>)}
      </div>
    </div>;
}